import { $, $all, on, forEach, addClass, removeClass } from "@olmokit/dom";
import { globalData } from "@olmokit/core/data";
import { post } from "@olmokit/core/fragments/ajax";
// import LazyLoad from "@olmokit/core/lazy";
export { postCart as postCart } from './Cart';
export { deleteItem as deleteItem } from './Cart';
export { itemIntheCart as itemIntheCart } from './Cart';
import { ConfiguratorMinimal } from './Minimal';
import { ConfiguratorRecap } from './Recap';
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
// export { ProductCard as ProductCard } from './Card';
import { dataLayerConfigurator } from "components/Datalayer";
import scrollLock from "@olmokit/core/scroll/lock";
import "./index.scss";

/**
 * Component: Configurator
 */
export function Configurator() {
  console.log("Configurator mounted.");

  PropertyOption();
  FiltersToLoadingPage();
  PreCompileFilters();
  ConfiguratorRecap();

  const $minimal = $(".ConfiguratorMinimal:").getAttribute('data-minimal');
  if(parseInt($minimal) > 0){
    ConfiguratorMinimal();
  }  

  const $typpy = $all('.Configurator:property_value-label--icon');
  forEach($typpy, (tooltip) => {
    tippy(tooltip, {
        theme: 'atlasplan',
        arrow: true,
        placement: "top"
    });
  }); 

  const $mobileConf = $('.productsingle:configurator_mobile');
  const $mobileConfClose = $('.Configurator:inner_close');
  const $config = $('.Configurator:');
  const $props = $all('.Configurator:property');
  if (window.innerWidth < 992) {
    forEach($props, (prop) => {
      prop.removeAttribute('open');
    });
  } else {
    forEach($props, (prop) => {
      prop.setAttribute('open', '');
    });
  }
  on($mobileConf, 'click', () => {
    addClass($config, 'open-config');
    document.body.style.overflow = 'hidden';
  });
  on($mobileConfClose, 'click', () => {
    removeClass($config, 'open-config');
    document.body.style.overflow = 'inherit';
  });

}

/** 
 * Setup the property store 
 * */
  let property = {};

export function PropertyOption(urlrequest = 'minimals') {

  const filters = $all('.Configurator:property_value');

  forEach(filters, (el) => {
    on(el, 'click', (e) => {

      e.preventDefault();
      const $filter = $('.Configurator:property_value-checkbox', el);
      const $label = $('.Configurator:property_value-label', el);
      const $filters = $all('.Configurator:property_value-checkbox');
      const id = $filter.getAttribute('data-id');
      const propname = $filter.getAttribute('data-property');
      const filtername = $filter.getAttribute('data-filter');
      const value = $filter.getAttribute('value');

      if(!el.classList.contains('is-filter')){

        forEach($filters, (filter) => {

          const removeId = filter.getAttribute('data-id');
          const removeValue = filter.getAttribute('value');
  
          if(filter.parentNode.classList.contains('is-filter') && id == filter.getAttribute('data-id')){
            removeClass(filter.parentNode, 'is-filter');
            storeProperty('remove', removeId, removeValue);
            setParams('remove', removeId, property[removeId], propname, filtername);          
          }
  
        });        

        addClass(el, 'is-filter');
        
        /** Push value in the store and set params */   
        storeProperty('add', id, value);
        setParams('add', id, property[id], propname, filtername);

        setRecap('add', id, $label.innerHTML);
        setRecapMobile('add', id, $label.innerHTML);

        productRefresh(property, urlrequest);
        

      } else {

        if(el.getAttribute('prop-name') == 'size' || 
           el.getAttribute('prop-name') == 'color' ||
           el.getAttribute('prop-name') == 'look')
        {

        } else {
          el.classList.remove('is-filter');

          /** Push value in the store and set params */   
          storeProperty('remove', id, value);
          setParams('remove', id, property[id], propname, filtername);
  
          setRecap('remove', id, $label.innerHTML);

          productRefresh(property, urlrequest);
        }

      }      

    });
  });  

}

/**
 * This function manage the filters activation by loading the page
 * if the params are in the url
 */
 let valuesObj = [];

 export function FiltersToLoadingPage(urlrequest = 'minimals') {

  let url = window.location.href;
  let urlUrl = new URL(url);
  let params = new URLSearchParams(urlUrl.search.slice(1));

  const filters = $all('.Configurator:property_value');

  let array;  
  let val = {};

  for (let p of params) {

    val[p[0]] = p[1];
    let rawArray = JSON.parse("[" + p[1] + "]");
    val[p[0]] = rawArray;
    array = rawArray;

    property = val;

    forEach(filters, (el) => {
      const filter = $('.Configurator:property_value-checkbox', el);
      const $label = $('.Configurator:property_value-label', el);
      const id = filter.getAttribute('data-id');
      const value = filter.getAttribute('value');

      // addClass(el, 'is-notactive');

      if (array.includes(parseInt(value))) {
        addClass(el, 'is-filter');

        setRecap('add', id, $label.innerHTML);
        setRecapMobile('add', id, $label.innerHTML);

        if (!valuesObj[id]) {
          valuesObj[id] = [value];
        } else {
          valuesObj[id].push(value);
        }
      }
    });

  }

  if(valuesObj.length > 0){
    productRefresh(valuesObj, urlrequest);
  }

  // if(window.innerWidth > 992){
    LargeImage();
  // }

}

/**
 * Setup the summary
 */
function setRecap(type, id, text) {
  const recapValue = $('.props-' + id);
  if(type == 'add'){
    recapValue.innerHTML = text;
  } else {
    recapValue.innerHTML = '';    
  }
}
function setRecapMobile(type, id, text) {
  const recapValue = $('.mobileProps-' + id);
  if(type == 'add'){
    recapValue.innerHTML = text;
  } else {
    recapValue.innerHTML = '';
  }
}

export function storeProperty(type, id, value) {
  if(type == 'add'){
    if(property[id]){
      property[id].push(value);
    } else {
      property[id] = [value];
    }
  } else if(type == 'remove') {    
    const size = Object.keys(property).length;
    if(size == 1 && property[id].length == 0){
      property = [];
    } else {
      const arr = property[id].filter((e) => e != value);
      property[id] = arr;
      if(property[id].length == 0) {
        delete property[id];
      }
    }
  }  
}


export function setParams(type, name, value, propname, filtname) {
  let url = window.location.href;
  let urlUrl = new URL(url);
  let params = new URLSearchParams(urlUrl.search.slice(1));

  const size = Object.keys(property).length;

  const h1 = $('.h1').getAttribute('data-title');
  // console.log(h1);

  if(type == 'add'){
    /** Just add a param */
    params.set(name, value);
    window.history.replaceState({}, "", `${location.pathname}?${params}`);
    // datalayer for filters
    dataLayerConfigurator('add', h1, propname, filtname);
  } else {
    /** Check if there is no value */
    if(size == 0){
      window.history.replaceState({}, "", `${location.pathname}`);
    } else {
      /** 
       * Check if the value is true means the property still has value 
       * otherwise delete the property
       * */
      if(value){
        params.set(name, value);
      } else {
        params.delete(name);
      }
      window.history.replaceState({}, "", `${location.pathname}?${params}`);
      // datalayer for filters
      dataLayerConfigurator('remove', h1, propname, filtname);
    }
  }
}

export function productRefresh(data, urlrequest) {

  // const values = $all('.Configurator:property_value');
  // forEach(values, (el) => {
  //   el.classList.add('is-notactive');
  // });

  let queryValues = [];
 
  for (const [key, value] of Object.entries(data)) {
    queryValues.push(JSON.parse("[" + value + "]"));
  }

  const loader = $('.Loader:');

  const $minimals = $('.Configurator:minimal');

  loader.style.display = 'flex';

  console.log('values', JSON.stringify(queryValues));

  post(urlrequest, {
    data: {
      id: JSON.stringify(queryValues),
      productid: globalData.productid,
      url: window.location.href
    },
  }).then(({ data }) => {
    $minimals.innerHTML = data;
    // new LazyLoad();

    loader.style.display = 'none';

    import("./Minimal").then(({ConfiguratorMinimal}) => {
      ConfiguratorMinimal();
    })

    const minimal = $(".ConfiguratorMinimal:").getAttribute('data-minimal');
    const buttonGetInfo = $(".buttonGetInfo");
    if(minimal == "0"){
      addClass(buttonGetInfo, 'noInfo');
    } else {
      removeClass(buttonGetInfo, 'noInfo');
    }

    // if(window.innerWidth > 992){
      LargeImage();
    // }

    // disableProperty();
  });
}

function PreCompileFilters() {
  const minimalproperty = globalData.minimalproperty;
  let array = [];
  let val = {};  

  if(minimalproperty){
    array = minimalproperty;
    // forEach(minimalproperty, (prop) => {
    //   array.push(prop.id);
    // });

    const filters = $all('.Configurator:property_value');

    forEach(filters, (el) => {
      const filter = $('.Configurator:property_value-checkbox', el);
      const $label = $('.Configurator:property_value-label', el);
      const id = filter.getAttribute('data-id');
      const propname = filter.getAttribute('data-property');
      const filtername = filter.getAttribute('data-filter');
      const value = filter.getAttribute('value');

      if (array.includes(parseInt(value))) {
        val[id] = value;
        let rawArray = JSON.parse("[" + value + "]");
        val[id] = rawArray;
    
        property = val;
      }

      if (array.includes(parseInt(value))) {
        el.classList.add('is-filter');
        setParams('add', id, value, propname, filtername);
        setRecap('add', id, $label.innerHTML);
        setRecapMobile('add', id, $label.innerHTML);

        if (!valuesObj[id]) {
          valuesObj[id] = [value];
        } else {
          valuesObj[id].push(value);
        }

      }
    });
    // disableProperty();
  }
}

function disableProperty() {
  const values = $all('.Configurator:property_value');
  const productsValids = $(".ConfiguratorMinimal:").getAttribute('data-valids');
  let valids = JSON.parse(productsValids);
  
  forEach(values, (el) => {
    const dataname = el.getAttribute('prop-name');
    if(dataname != 'size' && dataname != 'color' && dataname != 'look'){
      addClass(el, 'is-notactive');
    }
  });

  forEach(values, (el) => {

    const filter = $('.Configurator:property_value-checkbox', el);
    const value = filter.getAttribute('value');
    const intValue = parseInt(value);

    if(valids.includes(intValue)){
      el.classList.remove('is-notactive');
    }

  });
}

function LargeImage() {

  const $image = $all('.ConfiguratorMinimal:slab-inner__img');

  forEach($image, (image) => {
    on(image, 'click', () => {
      // console.log('click');
      const src = image.getAttribute('data-original');
      PostLargeImage(src);
    });
  });

}

function PostLargeImage(src) {
  post('image', {
    data: {
      src: src,
    },
  }).then(({ data }) => {
    // console.log(data);
    const $image = $('.ImageFullContainer');
    $image.innerHTML = data;
    $image.style.display = 'block';
    scrollLock.disable(document.body);
    const $close = $('.close', $image);
    // new LazyLoad();

    on($close, 'click', () => {
      $image.style.display = 'none';
      scrollLock.enable(document.body);
    });

    // use keyboard to close img
    document.addEventListener('keydown', evt => {
      if (evt.key === 'Escape') {
        $image.style.display = 'none';
        scrollLock.enable(document.body);
      }
    });

    // loader.style.display = 'none';

  });

}